import _ from 'lodash'
import uuid from 'uuid/v4'

import Client from "data/_client"
import toggles from 'feature-toggles'


type EventData = {
  // the object modified/created
  target?: {
    propertyid?: number
    folderid?: number
  }
  // the object copied and/or folder where it occurred
  source?: {
    filename?: string
    propertyid?: number
    folderid?: number
    chartid?: number
  }
  // the folder where it ended up
  destination?: {
    folderid?: number
    chartid?: number
  }
}

export async function logEvent(event: string, data:EventData, correlationid?: string) {
  correlationid = correlationid || uuid()
  const payload = {
    event,
    data
  }
  await Client.post(`history/mark`, payload, {headers: {correlationid}})
  return correlationid
}